import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import EventSourceForm from '@/components/events/EventSourceForm.vue';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import { EventsActions, EventsState } from '@/stores/events.store';
import { EventSource } from '@/models/event-source.model';
import { useEvents, Event } from '@/services/events.composable';
import ListFilter from '../common/ListFilter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsSourcesList',
  setup(__props) {

const store = useStore<ShiftCMSState & { ev: EventsState }>();
const sources = computed<EventSource[]>(() => store.state.ev.sources);
const events = useEvents();

const update = () => {
  store.dispatch(EventsActions.GetEventSources);
};

onMounted(() => {
  update();
  events.on(Event.LanguageChanged, update);
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
  events.off(Event.LanguageChanged, update);
});

const editEventSource = (_: Event, { item }: { item: EventSource }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(EventSourceForm),
    data: item,
  });
};

const addEventSource = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(EventSourceForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Name', key: 'name', width: '20%' },
  { title: 'URL', key: 'url', width: '25%' },
  { title: 'Last run', key: 'lastSuccessfulRun', width: '15%' },
  { title: 'Events', key: 'lastEventCount', width: '5%' },
  { title: 'State', key: 'translated', width: '10%' },
];

const filter = ref<string>('');
const filterTitle = ref<string>('');
const filteredItems = computed<EventSource[]>(() => {
  return sources.value.filter((v: EventSource) => {
    if (filterTitle.value) {
      return [v.url]
        .map((s) => s.toLowerCase())
        .join('')
        .includes(filterTitle.value);
    }

    return true;
  });
});

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filter.value = filters.filter;
  filterTitle.value = filters.filterTitle;

  console.log(filters.filter, filters.filterTitle);
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Event Sources", -1)),
      _createVNode(ListFilter, {
        dense: "",
        options: [],
        onFilter: updateFilter
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": editEventSource,
        headers: headers,
        items: filteredItems.value,
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.creationDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(format)(value, 'do MMMM yyyy - HH:mm')), 1)
        ]),
        "item.lastSuccessfulRun": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(value ? _unref(format)(value, 'do MMMM yyyy - HH:mm') : '-'), 1)
        ]),
        "item.translated": _withCtx(({ item }) => [
          (item.enabled)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                icon: "mdi-eye-check",
                color: "success"
              }))
            : (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                icon: "mdi-eye-outline",
                color: "warning"
              }))
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addEventSource,
        color: "success"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Add Event Source")
        ])),
        _: 1
      }),
      _cache[2] || (_cache[2] = _createTextVNode("  "))
    ]),
    _: 1
  }))
}
}

})